import { render, staticRenderFns } from "./imprimir_relatorio_cadastro.vue?vue&type=template&id=412bff63&scoped=true&"
import script from "./imprimir_relatorio_cadastro.vue?vue&type=script&lang=js&"
export * from "./imprimir_relatorio_cadastro.vue?vue&type=script&lang=js&"
import style0 from "./imprimir_relatorio_cadastro.vue?vue&type=style&index=0&id=412bff63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412bff63",
  null
  
)

export default component.exports